import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PRICE_LANE_CSV_HEADERS } from '@domain/constants/csv-headers';
import { DIFFERENCE_IN_DAYS, IS_VALID_DATE } from 'cargo-chief-commons';
import {
	ACCEPTED_DATE_FORMATS,
	IS_EMPTY_LINE,
	IS_VALID_LINE,
	MAP_HEADERS,
	MAP_INDICES,
} from '../shared/utils';
import { environment } from '@environment/environment';
import { CsvDataHelper } from '@domain/interface/data-map';

export const PRICE_LANE_DATA_MAP = (formBuilder: UntypedFormBuilder): CsvDataHelper => ({
	headersMap: [
		{ value: PRICE_LANE_CSV_HEADERS.ORIGIN_CITY, label: 'Origin City', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.ORIGIN_STATE, label: 'Origin State', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.DESTINATION_CITY, label: 'Destination City', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.DESTINATION_STATE, label: 'Destination State', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.TRAILER_TYPE, label: 'Trailer Type', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.PICKUP_DATE, label: 'Pickup Date', required: true },
		{ value: PRICE_LANE_CSV_HEADERS.DELIVERY_DATE, label: 'Delivery Date', required: false },
	],
	requiredHeaders: [
		PRICE_LANE_CSV_HEADERS.ORIGIN_CITY,
		PRICE_LANE_CSV_HEADERS.ORIGIN_STATE,
		PRICE_LANE_CSV_HEADERS.DESTINATION_CITY,
		PRICE_LANE_CSV_HEADERS.DESTINATION_STATE,
		PRICE_LANE_CSV_HEADERS.TRAILER_TYPE,
		PRICE_LANE_CSV_HEADERS.PICKUP_DATE,
		PRICE_LANE_CSV_HEADERS.DELIVERY_DATE,
	],
	fileDataValidator: (
		fileHeaders: string,
		fileData: string[],
		requiredHeaders: string[]
	): string[] => {
		let errors = [];
		let headers = fileHeaders.split(',');
		let headerMap = MAP_HEADERS(headers);
		let indicesMap = MAP_INDICES(headers);

		if (fileData.length > 0) {
			for (var i = 0; i < fileData.length; i++) {
				var line = fileData[i];
				if (IS_EMPTY_LINE(line)) {
					continue;
				}
				if (IS_VALID_LINE(line, indicesMap, requiredHeaders)) {
					var rowElements = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

					var pickupDateValue = rowElements[headerMap[PRICE_LANE_CSV_HEADERS.PICKUP_DATE]];
					if (!IS_VALID_DATE(pickupDateValue, ACCEPTED_DATE_FORMATS)) {
						errors.push(
							'Invalid date format for pick up date: ' +
								pickupDateValue +
								'. Accepted formats: M/D/Y, M-D-Y, Y-M-D'
						);
					}

					var deliveryDateValue = rowElements[headerMap[PRICE_LANE_CSV_HEADERS.DELIVERY_DATE]];
					if (!IS_VALID_DATE(deliveryDateValue, ACCEPTED_DATE_FORMATS)) {
						errors.push(
							'Invalid date format for delivery date: ' +
								deliveryDateValue +
								'. Accepted formats: M/D/Y, M-D-Y, Y-M-D'
						);
					}

					if (DIFFERENCE_IN_DAYS(pickupDateValue, deliveryDateValue) < 1) {
						errors.push('Delivery date cannot be before pickup.');
					}
				} else {
					errors.push('Invalid line: ' + line);
					break;
				}
			}
		} else {
			errors.push('No record found.');
		}
		return errors;
	},
	formGroupBuilder: (): UntypedFormGroup => {
		let form: UntypedFormGroup;
		form = formBuilder.group({
			[PRICE_LANE_CSV_HEADERS.ORIGIN_CITY]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.ORIGIN_STATE]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.DESTINATION_CITY]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.DESTINATION_STATE]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.TRAILER_TYPE]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.PICKUP_DATE]: ['', Validators.required],
			[PRICE_LANE_CSV_HEADERS.DELIVERY_DATE]: ['', Validators.required],
		});
		return form;
	},
	fileUploadBucketName: environment.BULK_MATCH_CONFIG.priceLane.bucketName,
});
